import { GridClasses } from '../constants'
import style from './index.module.scss'

const styles: GridClasses = {
  root: style.root!,
  'root--densityStandard': '',
  'root--densityComfortable': '',
  'root--densityCompact': '',
  autoHeight: style.autoHeight!,
  main: style.main!,

  // Header
  columnHeaders: style.columnHeaders!,
  columnHeadersInner: style.columnHeadersInner!,
  'columnHeadersInner--scrollable': style['columnHeadersInner--scrollable']!,

  pinnedColumnHeaders: style.pinnedColumnHeaders!,
  'pinnedColumnHeaders--left': style['pinnedColumnHeaders--left']!,
  'pinnedColumnHeaders--right': style['pinnedColumnHeaders--right']!,

  columnHeader: style.columnHeader!,
  columnHeaderRow: style.columnHeaderRow!,
  'columnHeader--alignCenter': style['columnHeader--alignCenter']!,
  'columnHeader--alignLeft': style['columnHeader--alignLeft']!,
  'columnHeader--alignRight': style['columnHeader--alignRight']!,
  'columnHeader--sortable': style['columnHeader--sortable']!,
  'columnHeader--sorted': style['columnHeader--sorted']!,
  'columnHeader--moving': style['columnHeader--moving']!,
  columnHeaderDropZone: style.columnHeaderDropZone!,
  'columnHeader--dragging': style['columnHeader--dragging']!,
  columnHeaderDraggableContainer: style.columnHeaderDraggableContainer!,
  columnHeaderTitleContainer: style.columnHeaderTitleContainer!,
  columnHeaderTitleContainerContent: style.columnHeaderTitleContainerContent!,
  columnHeaderTitle: style.columnHeaderTitle!,
  columnHeaderButtonContainer: style.columnHeaderButtonContainer!,

  columnSeparator: style.columnSeparator!,
  'columnSeparator--resizable': style['columnSeparator--resizable']!,
  'columnSeparator--resizing': 'columnSeparator--resizing',
  'columnSeparator--sideLeft': style['columnSeparator--sideLeft']!,
  'columnSeparator--sideRight': style['columnSeparator--sideRight']!,

  // Content
  virtualScroller: style.virtualScroller!,
  // Todo @devarsh - Need to check
  virtualScrollerContent: 'dataGrid__scrollerContent',
  virtualScrollerRenderZone: style.virtualScrollerRenderZone!,

  pinnedRows: style.pinnedRows!,
  'pinnedRows--top': style['pinnedRows--top']!,
  'pinnedRows--bottom': style['pinnedRows--bottom']!,
  pinnedRowsRenderZone: '',

  pinnedColumns: style.pinnedColumns!,
  'pinnedColumns--left': style['pinnedColumns--left']!,
  'pinnedColumns--right': style['pinnedColumns--right']!,

  // row & cell
  row: style.row!,
  'row--editable': '',
  'row--editing': '',
  columnFooterRow: style.columnFooterRow!,
  skeletonRow: style.skeletonRow!,
  'row--hovered': style['row--hovered']!,
  'row--selected': style['row--selected']!,
  'row--dynamicHeight': style['row--dynamicHeight']!,
  cell: style.cell!,
  'cell--textCenter': style['cell--textCenter']!,
  'cell--textLeft': style['cell--textLeft']!,
  'cell--textRight': style['cell--textRight']!,
  'cell--editable': style['cell--editable']!,
  'cell--editing': '',
  cellContent: style.cellContent!,
  cellColumnHeader: style.cellColumnHeader!,

  // overlay
  overlay: style.overlay!,
  overlayWrapper: style.overlayWrapper!,
  // @devarsh - Need to check
  overlayWrapperInner: 'dataGrid__overlayWrapperInner',
  withBorder: style.withBorder!,
  cellError: style.hasError!,
  cellSkeleton: '',
}

export default styles
